import React from 'react';
import PropTypes from 'prop-types';

const PopupOverlay = ({ isOpen, children, onOverlayClick, isBlock, style }) => {
  return (
    <div
      className={`popup-overlay ${isOpen && 'popup-overlay--open'}`}
      style={{
        backgroundColor: isBlock
          ? 'rgba(255, 255, 255, 1)'
          : 'rgba(0, 0, 0, 0.4)',
        ...style
      }}
    >
      <div
        role="presentation"
        className="popup-overlay_bg"
        onClick={onOverlayClick}
      />
      <div className="popup-overlay_children">{children}</div>
    </div>
  );
};

PopupOverlay.propTypes = {
  isOpen: PropTypes.bool,
  onOverlayClick: PropTypes.func,
  children: PropTypes.node,
  isBlock: PropTypes.bool,
  style: PropTypes.object
};

export default PopupOverlay;
